import React from 'react';
import { motion } from 'framer-motion';
import { FiBarChart2, FiTv } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const AddonsSection = () => {
  const addons = [
    {
      title: "Stat Matrix Widgets",
      kicker: "Intelligence",
      desc: "Enhance your newsfeed articles with deep-dive data visualizations for players, clubs, and matches. Embed real-time performance metrics directly inside the news content.",
      icon: FiBarChart2
    },
    {
      title: "Broadcast Locators",
      kicker: "Monetization",
      desc: "Enrich your newsfeed with widgets that automatically show users where they can watch the matches mentioned in the articles. Monetize your feed by including customizable affiliate links for streaming partners.",
      icon: FiTv
    }
  ];

  return (
    <section className="py-32 border-b border-white/5">
      <div className="max-w-7xl mx-auto px-6">
        <header className="mb-20">
          <h2 className="text-[#CCFF00] font-mono-data text-xs font-black uppercase tracking-[0.4em] mb-6">Newsfeed Extensions</h2>
          <h3 className="text-5xl md:text-7xl font-black text-white tracking-tighter uppercase leading-[0.9]">
            Powerful <span className="text-transparent" style={{ WebkitTextStroke: '1px #CCFF00' }}>Newsfeed Addons</span>
          </h3>
        </header>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {addons.map((addon, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="glass-card p-10 relative overflow-hidden group"
            >
              <div className="flex items-start justify-between mb-12">
                <div className="w-16 h-16 bg-[#CCFF00] flex items-center justify-center text-black">
                  <SafeIcon icon={addon.icon} className="text-3xl" />
                </div>
                <div className="text-right">
                  <span className="text-[#CCFF00] font-mono-data text-[10px] font-black uppercase tracking-widest block mb-1">
                    {addon.kicker}
                  </span>
                  <span className="text-white font-black uppercase text-xs tracking-tighter">Module v3.1</span>
                </div>
              </div>

              <h4 className="text-3xl font-black text-white uppercase tracking-tighter mb-6 group-hover:text-[#CCFF00] transition-colors">
                {addon.title}
              </h4>
              
              <p className="text-slate-400 text-lg font-medium leading-relaxed">
                {addon.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AddonsSection;